import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { LicenseWarnDialogService } from './license-warn-dialog.service';
import { DisplayDatePipe } from '../../pipes/display-date.pipe';

/**
 * The warn-with-evidence interstitial (compliance-check-dialog pattern — root-mounted
 * in app.component.html). Copy is reason-split (expired = "cleared until DATE" class; not-yet-valid
 * = "not cleared until START-DATE") with the dates embedded in the body; ONE shared generic title
 * (deliberate — cmp-8a). Footer = the dialog-footer canon: pButton text Cancel + OUTLINED Continue
 * (neutral — a warn is non-destructive; uiux-3).
 */
@Component({
  selector: 'app-license-warn-dialog',
  standalone: true,
  imports: [DisplayDatePipe, TranslateModule, DialogModule, ButtonModule],
  templateUrl: './license-warn-dialog.component.html',
  styleUrl: './license-warn-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LicenseWarnDialogComponent {
  protected readonly dialog = inject(LicenseWarnDialogService);

  protected readonly isExpired = computed(() => this.dialog.evidence()?.reason !== 'NOT_YET_VALID');
  protected readonly names = computed(() => this.dialog.evidence()?.sampleAssetNames ?? []);

  onVisibleChange(visible: boolean): void {
    if (!visible) this.dialog.decide(false);
  }
}
